import { useStyles } from './styles'

type BackgroundShadingProps = {
  width?: string
  height?: string
  top?: string
  bottom?: string
  startColor?: string
  endColor?: string
  zIndex?: number
  upsideDown?: boolean
  left?: string
} & React.CSSProperties

export const BackgroundShading = (props: BackgroundShadingProps) => {
  const { classes } = useStyles()
  const { width, height = '52px', top, left, startColor, endColor, upsideDown, zIndex, bottom, ...styles } = props
  return (
    <div
      className={classes.root}
      style={{
        width: width,
        height: height,
        left: left,
        top: top,
        bottom: bottom,
        zIndex: zIndex,
        backgroundImage:
          startColor && endColor
            ? `linear-gradient(0deg, ${endColor} 0%, ${startColor} 100%)`
            : 'linear-gradient(0deg, #1D1E22 0%, rgba(18, 18, 20, 0) 100%)',
        transform: upsideDown ? 'rotate(180deg)' : 'rotate(0deg)',
        ...styles,
      }}
    />
  )
}
